import React, { memo } from 'react';
import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { Button, BUTTON } from 'components/common/Button/Button';
import ReportDialogTitle from './ReportDialogTitle';
import styles from './ReportDialogs.scss';

const DialogRemoveUsers = ({ dialogOpen, toggleDialog, onConfirm }) => {
    const onRemoveClick = () => {
        onConfirm();
        toggleDialog();
    };

    return (
        <div data-cy="DialogRemoveUsers">
            <Dialog
                open={dialogOpen}
                onClose={toggleDialog}
                fullWidth
                aria-labelledby="form-dialog-title"
                className={styles.dialogContainer}
            >
                <ReportDialogTitle onClose={toggleDialog} children={'Remove Users from Report'} />
                <DialogContent>
                    <Typography gutterBottom>
                        The selected users will be removed from this email list and will no longer receive reports.
                    </Typography>
                    <Typography />
                    <Typography gutterBottom>Are you sure you want to remove these users?</Typography>
                    <Typography />
                </DialogContent>
                <DialogActions className={styles.dialogAction}>
                    <Button
                        className={styles.btnOutline}
                        onClick={toggleDialog}
                        bgcolor={BUTTON.BGCOLOR.CLEAR}
                        color={BUTTON.COLOR.GREY}
                    >
                        Cancel
                    </Button>
                    <Button onClick={onRemoveClick} bgcolor={BUTTON.BGCOLOR.ORANGE} color={BUTTON.COLOR.WHITE}>
                        Remove Users
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default memo(DialogRemoveUsers);
